class SearchDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('[data-sd-overlay]');
    this.panel = this.querySelector('[data-sd-panel]');
    this.input = this.querySelector('#SearchDrawer-Input');
    this.resetBtn = this.querySelector('[data-sd-reset]');
    this.most = this.querySelector('.sd__most');

    this._onKeydown = this._onKeydown.bind(this);
    this._onClick = this._onClick.bind(this);

    document.addEventListener('click', this._onClick, true);

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Toggle "Most searched" when typing (premium fade)
if (this.input && this.most) {
  const resultsHost = this.querySelector('[data-sd-results]');
  const apply = (el, show) => {
    if (!el) return;
    el.classList.toggle('sd-fade-in', show);
    el.classList.toggle('sd-fade-out', !show);
    // only hard-disable after fade
    if (show) {
      el.style.display = '';
    } else {
      window.setTimeout(() => { el.style.display = 'none'; }, 220);
    }
  };

  const toggleMost = () => {
    const hasValue = !!this.input.value.trim();
    apply(this.most, !hasValue);
    if (resultsHost) apply(resultsHost, hasValue);
  };

  // init classes
  this.most.classList.add('sd-fade-in');
  if (resultsHost) resultsHost.classList.add('sd-fade-out');

  this.input.addEventListener('input', toggleMost);
  toggleMost();
}

    // Optional: keep reset button visibility in sync (extra safety)
    if (this.input && this.resetBtn) {
      const syncReset = () => {
        // SearchForm also toggles, but this helps if anything fails
        if (this.input.value.trim()) this.resetBtn.classList.remove('hidden');
        else this.resetBtn.classList.add('hidden');
      };
      this.input.addEventListener('input', syncReset);
      syncReset();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onClick, true);
    document.removeEventListener('keydown', this._onKeydown);
  }

  open(opener = null) {
    this._opener = opener || document.activeElement;

    this._lockScroll();

    this.classList.remove('is-closing');
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');

    document.addEventListener('keydown', this._onKeydown, { passive: false });

    window.setTimeout(() => {
      this.panel?.focus?.();
      this.input?.focus?.();
      this.input?.select?.();
    }, 30);
  }

  close() {
    if (!this.classList.contains('is-open')) return;

    this.classList.add('is-closing');
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');

    document.removeEventListener('keydown', this._onKeydown, { passive: false });

    window.setTimeout(() => {
      this.classList.remove('is-closing');
      this._unlockScroll();
      if (this._opener && typeof this._opener.focus === 'function') this._opener.focus();
      this._opener = null;
    }, 950);
  }

  _onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
    }
  }

  _onClick(e) {
    const opener = e.target.closest('[data-sd-open]');
    if (opener) {
      e.preventDefault();
      this.open(opener);
      return;
    }

    const closer = e.target.closest('[data-sd-close]');
    if (closer && this.contains(closer)) {
      e.preventDefault();
      this.close();
      return;
    }
  }

  _lockScroll() {
    const html = document.documentElement;
    const n = Number(html.dataset.drawerLockCount || 0) + 1;
    html.dataset.drawerLockCount = String(n);
    html.classList.add('drawer-lock');
  }

  _unlockScroll() {
    const html = document.documentElement;
    const cur = Number(html.dataset.drawerLockCount || 0);
    const next = Math.max(0, cur - 1);
    html.dataset.drawerLockCount = String(next);
    if (next === 0) html.classList.remove('drawer-lock');
  }
}

customElements.define('search-drawer', SearchDrawer);
